(() => {
  'use strict';

  const WELCOME_KEY = 'ld_welcome_complete_v2';
  const HANDOFF_KEY = 'ld_welcome_handoff_v2';
  const WINDOW_MARK = '|ld_welcome_complete_v2|';
  const rootUrl = window.Shopify?.routes?.root || '/';
  const leavingWelcomes = new WeakSet();

  const designMode = () => Boolean(window.Shopify?.designMode || document.documentElement.dataset.r7DesignMode === 'true');
  const markWindow = () => {
    try {
      if (!window.name.includes(WINDOW_MARK)) window.name += WINDOW_MARK;
    } catch (_error) {}
  };
  const store = (mode) => {
    const record = { mode, timestamp: Date.now() };
    try {
      sessionStorage.setItem(WELCOME_KEY, '1');
      sessionStorage.setItem(HANDOFF_KEY, JSON.stringify(record));
    } catch (_error) {}
    markWindow();
    return record;
  };
  const readHandoff = () => {
    try {
      const raw = sessionStorage.getItem(HANDOFF_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (_error) {
      return null;
    }
  };
  const clearHandoff = () => {
    try { sessionStorage.removeItem(HANDOFF_KEY); } catch (_error) {}
  };
  const nextHomeUrl = (mode) => {
    const url = new URL(rootUrl, location.origin);
    url.searchParams.set('ld_welcome', '1');
    if (mode === 'ai') url.searchParams.set('open_ai', '1');
    return `${url.pathname}${url.search}`;
  };

  const replaceAfterOnePaint = (url) => {
    let completed = false;
    const navigate = () => {
      if (completed) return;
      completed = true;
      document.removeEventListener('visibilitychange', onVisibilityChange);
      window.location.replace(url);
    };
    const onVisibilityChange = () => {
      if (document.hidden) navigate();
    };

    if (document.hidden || typeof window.requestAnimationFrame !== 'function') {
      navigate();
      return;
    }

    document.addEventListener('visibilitychange', onVisibilityChange);
    try {
      window.requestAnimationFrame(() => {
        if (document.hidden) {
          navigate();
          return;
        }
        try {
          window.requestAnimationFrame(navigate);
        } catch (_error) {
          navigate();
        }
      });
    } catch (_error) {
      navigate();
    }
  };

  const handleWelcome = () => {
    if (designMode()) return;
    const welcome = document.querySelector('[data-ld-welcome]');
    if (!welcome) return;
    welcome.querySelectorAll('[data-dv2-welcome-home], [data-dv2-welcome-ai]').forEach((trigger) => {
      if (trigger.dataset.dv2WelcomeBound === 'true') return;
      trigger.dataset.dv2WelcomeBound = 'true';
      trigger.addEventListener('click', (event) => {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        if (leavingWelcomes.has(welcome)) return;
        leavingWelcomes.add(welcome);

        const mode = trigger.hasAttribute('data-dv2-welcome-ai') ? 'ai' : 'home';
        trigger.setAttribute('aria-busy', 'true');

        if (mode === 'home') {
          welcome.dataset.exitState = 'EXIT_TO_HOME';
          welcome.dataset.activePath = 'home';
          welcome.classList.add('is-exit-to-home');
        }

        store(mode);
        document.dispatchEvent(new CustomEvent('dv2_welcome_choice', {
          detail: { choice: mode, sectionId: welcome.dataset.sectionId || '' }
        }));

        if (mode === 'home') {
          replaceAfterOnePaint(nextHomeUrl(mode));
          return;
        }

        window.location.replace(nextHomeUrl(mode));
      });
    });
    document.dispatchEvent(new CustomEvent('dv2_welcome_view'));
  };

  const cleanHomeQuery = () => {
    const url = new URL(location.href);
    const hadMarker = url.searchParams.has('ld_welcome') || url.searchParams.has('open_ai');
    url.searchParams.delete('ld_welcome');
    url.searchParams.delete('open_ai');
    if (hadMarker) history.replaceState(history.state, '', `${url.pathname}${url.search}${url.hash}`);
  };

  const openAIFromHandoff = () => {
    const url = new URL(location.href);
    const handoff = readHandoff();
    const shouldOpen = url.searchParams.get('open_ai') === '1' || handoff?.mode === 'ai';
    const home = document.querySelector('[data-dv2-home]');
    if (home) {
      const welcomeHome = handoff?.mode === 'home'
        || (url.searchParams.get('ld_welcome') === '1' && url.searchParams.get('open_ai') !== '1');
      home.dataset.entryMode = welcomeHome ? 'welcome' : 'direct';
      home.classList.toggle('is-welcome-handoff', welcomeHome);
    }
    cleanHomeQuery();
    clearHandoff();
    if (!shouldOpen || designMode()) return;

    let attempts = 0;
    const attempt = () => {
      attempts += 1;
      const trigger = document.querySelector('[data-dv2-shortcuts] [data-ld-ai-trigger], [data-dv2-home] [data-ld-ai-trigger]');
      if (trigger && window.LDDivettaAssistant?.open?.(trigger)) return;
      if (attempts < 40) window.setTimeout(attempt, 125);
    };
    attempt();
  };

  const init = () => {
    handleWelcome();
    if (location.pathname === rootUrl || location.pathname === '/') openAIFromHandoff();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector?.('[data-ld-welcome]')) handleWelcome();
  });
})();
